import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import {
    SubjectMonitoringReviewTypeDto,
    SubjectMonitoringReviewTypePostDto,
} from '@interfaces-clean/subject-monitoring-review-type.interface';
import { getData, postData } from '@apis/rest-client';

const urlPrefix = 'SubjectMonitoring';
const timeout = 30000;

export const SubjectMonitoringReviewTypeAPI = {
    useGetAll: () =>
        useSWR(`${urlPrefix}/GetAll`, (url) => getData<SubjectMonitoringReviewTypeDto[]>(url, { timeout })),

    useAdd: () =>
        useSWRMutation(`${urlPrefix}/Add`, (url, { arg }: { arg: SubjectMonitoringReviewTypePostDto }) =>
            postData<SubjectMonitoringReviewTypePostDto, number>(url, { arg, timeout }),
        ),

    useUpdate: (recordId: number | null) => {
        const url = recordId != null ? `${urlPrefix}/Update/${recordId}` : null;
        return useSWRMutation(url, (resolvedUrl, { arg }: { arg: SubjectMonitoringReviewTypePostDto }) =>
            postData<SubjectMonitoringReviewTypePostDto, void>(resolvedUrl, { arg, timeout }),
        );
    },
} as const;
